import { useEffect, useCallback } from 'react'
import { useDispatch } from 'react-redux'

import BtnList from '@App/components/BtnList/BtnList'
import IconBtnHor from '@App/components/IconBtnHor/IconBtnHor'

import './analysis-toggles.css'

function AnalysisToggles({ types, activeTypeIds, setActiveTypeIds }) {
  const dispatch = useDispatch()

  const toggleTypes = useCallback((newActiveTypeIds) => {
    dispatch(setActiveTypeIds(newActiveTypeIds))
  }, [dispatch, setActiveTypeIds])

  useEffect(() => {
    if (activeTypeIds === undefined && types && types.length > 0) {
      toggleTypes(types.map(type => type.id))
    }
  }, [toggleTypes, activeTypeIds, types])

  if (!types || types.length === 0) {
    return <p className="analysis-toggles__no-data-message">No data to show for date</p>
  }

  if (!activeTypeIds) return null

  return (
    <div className="analysis-toggles">
      <BtnList>
        {types.map((type) => {
          const active = activeTypeIds.includes(type.id)

          return (
            <IconBtnHor
              key={type.id}
              iconProps={{
                icon: type.icon || '/img/icons/types/other/virus.svg',
                size: '24px',
              }}
              inactive={!active}
              onClick={() => {
                const newActiveTypeIds = active
                  ? activeTypeIds.filter(id => id !== type.id)
                  : [...activeTypeIds, type.id]
                toggleTypes(newActiveTypeIds)
              }}
            >
              <span>{type.label || type.name}</span>
              {(type.positive != null || type.negative != null) && (
                <span className="analysis-toggles__numbers">
                  {type.positive != null && (
                    <span className="analysis-toggles__numbers__positive">
                      {`${type.positive} positive`}
                    </span>
                  )}
                  {type.negative != null && (
                    <span className="analysis-toggles__numbers__negative">
                      {`${type.negative} negative`}
                    </span>
                  )}
                </span>
              )}
            </IconBtnHor>
          )
        })}
      </BtnList>
    </div>
  )
}

export default AnalysisToggles
